import { regionCodes } from '../../../../../enums/regions';

export default function checkIsExcludedCountryCode(country_code = '') {
	return (process.env.CPA_ENV === 'rocket' ? regionCodes.cis : ['RU', 'KZ', 'MD', 'GE']).includes(country_code);
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/checkIsExcludedCountryCode.js